import { Controller } from "@hotwired/stimulus"

// Manages dark/light theme toggle.
// Default: light mode (per UX spec).
// Persists preference in localStorage.
// Checks prefers-color-scheme as initial hint, but defaults to light.
export default class extends Controller {
  static targets = ["button"]

  connect() {
    this.applyTheme()
    this.updateIcon()
  }

  toggle() {
    const html = document.documentElement
    const isLight = html.classList.contains("light")

    if (isLight) {
      html.classList.remove("light")
      localStorage.setItem("bk-theme", "dark")
    } else {
      html.classList.add("light")
      localStorage.setItem("bk-theme", "light")
    }

    this.updateIcon()
  }

  applyTheme() {
    const saved = localStorage.getItem("bk-theme")
    const html = document.documentElement

    if (saved === "dark") {
      html.classList.remove("light")
    } else if (saved === "light") {
      html.classList.add("light")
    } else {
      // No saved preference — default to light mode per UX spec
      html.classList.add("light")
    }
  }

  updateIcon() {
    if (!this.hasButtonTarget) return
    const isLight = document.documentElement.classList.contains("light")
    this.buttonTarget.textContent = isLight ? "\uD83C\uDF19" : "\u2600\uFE0F"
  }
}
